import { useEffect, useState } from "react";
import { CopyBox } from "@/components/CopyBox";
import { api } from "@/lib/api";

export const Step = ({ n, title, children }) => (
  <section className="grid grid-cols-[2rem_1fr] gap-4">
    <div className="h-8 w-8 rounded-full border border-slate-900 grid place-items-center font-mono text-xs">{n}</div>
    <div className="space-y-3 min-w-0">
      <h3 className="font-display font-semibold text-lg">{title}</h3>
      {children}
    </div>
  </section>
);

export const EmergentSetup = ({ site }) => {
  const [helper, setHelper] = useState("");
  useEffect(() => { api.get("/kit/react-helper", { responseType: "text" }).then((r) => setHelper(r.data)).catch(() => {}); }, []);
  const script = `<script src="${site.kit_url}" data-key="${site.website_key}" data-mode="emergent"></script>`;
  const sitemap = `${site.api_base}/api/kit/v1/${site.website_key}/sitemap-es.xml`;
  return (
    <div className="space-y-10 max-w-4xl" data-testid="emergent-setup">
      <Step n="1" title="Paste the site kit in <head>">
        <p className="text-sm text-slate-600">Put this at the top of <span className="font-mono">public/index.html</span>, before other scripts. On <span className="font-mono">/es/</span> pages it loads the Spanish text before the first paint, so English never flashes. It sets <span className="font-mono">lang="es"</span>, the Spanish title, meta description and hreflang, and adds the EN | ES switcher.</p>
        <CopyBox value={script} testid="emergent-script-snippet" />
        <div className="text-xs text-slate-500">Website key: <span className="font-mono text-slate-800" data-testid="website-key">{site.website_key}</span></div>
      </Step>
      <Step n="2" title="Turn on /es/ routes with the React helper">
        <p className="text-sm text-slate-600">Save this as <span className="font-mono">src/morr/MorrTranslate.jsx</span> and swap <span className="font-mono">&lt;BrowserRouter&gt;</span> for <span className="font-mono">&lt;MorrRouter&gt;</span>. Every route then also works under <span className="font-mono">/es/</span>.</p>
        <CopyBox value={helper || "Loading…"} testid="react-helper-snippet" multiline />
      </Step>
      <Step n="3" title="Keep brand names, prices and addresses in English">
        <CopyBox value={`<span data-no-translate>Casa Verde™</span>  <span data-no-translate>$49.99</span>`} testid="no-translate-snippet" />
      </Step>
      <Step n="4" title="Submit the Spanish sitemap">
        <p className="text-sm text-slate-600">Add it in Google Search Console or link it from your <span className="font-mono">robots.txt</span>.</p>
        <CopyBox value={sitemap} testid="sitemap-url" />
      </Step>
      <p className="text-xs text-slate-500 border-t border-slate-200 pt-5">How it works: the kit finds text it hasn't seen yet (new pages, edited copy) and sends it for translation, and the Spanish shows on the next visit. No visitor waits on the AI. Spanish-language browsers see an optional "Ver en español" banner.</p>
    </div>
  );
};
